import React, { useState, useEffect } from 'react';
import styles from './TextInput.module.scss';

export type TextInputProps = {
  title?: string;
  placeholder?: string;
  onValueChange: any;
  required?: false | true;
  name?: string;
  fieldValidation?: string;
  type?: string;
  maxLength?: number;
  pattern?: string;
  value?: any;
  isDisabled?: boolean;
  max?: any;
  min?: any;
  step?: string;
  inputMode?: 'none' | 'text' | 'numeric' | 'tel' | 'decimal';
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  values?: any;
  isFieldInvalid?: boolean;
  onClick?: any;
  id?: string;
  isDateWorkedEmpty?: boolean;
};

const TextInput = ({
  title,
  placeholder,
  onValueChange,
  required,
  name,
  fieldValidation,
  type,
  maxLength,
  pattern,
  inputMode,
  value,
  min,
  max,
  step,
  isDisabled = false,
  handleChange,
  handleBlur,
  values,
  isFieldInvalid,
  onClick,
  id,
  isDateWorkedEmpty,
}: TextInputProps) => {
  const [showError, setError] = useState<boolean>();
  useEffect(() => {
    if (isFieldInvalid) {
      setError(true)
    } else {
      setError(false)
    }
  }, [isFieldInvalid])

  const validateField = (value) => {
    switch (fieldValidation) {
      case 'email':
        //eslint-disable-next-line
        if (value !== '' && /^[a-zA-Z][\w\.-]{1,28}[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/.test(value)) {

          setError(false);
        } else {

          setError(true);
        }
        break;
      case 'ssn':
        if (!value || value.length < 5 || value.length > 5) {
          setError(true);
        } else {
          setError(false);
        }
        break;
      case 'required':
        if (value !== '') {
          setError(false);
        } else {

          setError(true);
        }
        break;
      default:
    }
  };

  return (
    <div className={styles.Container} data-testid="TextInput" onClick={() => onClick(name)}>
      <label className={styles.ContainerLabel}>
        {title}
        {required ? <span className={styles.required}>*</span> : null}
      </label>
      <input
        id={id}
        maxLength={maxLength}
        pattern={pattern}
        inputMode={inputMode}
        name={name}
        type={type}
        disabled={isDisabled}
        max={max}
        min={min}
        value={values}
        step={step}
        className={
         ( showError || isDateWorkedEmpty)
            ? styles.ContainerTextArea + ' ' + styles.Error
            : styles.ContainerTextArea
        }
        placeholder={placeholder}
        onBlur={(event) => {
          handleBlur && handleBlur(event)
          validateField(event.target.value);
          if (name === 'email') {
            window.analytics.identify('EMAIL', { email: event.target.value });
          }
        }}
        onChange={(event) => {
          handleChange && handleChange(event)
          if (fieldValidation === 'ssn') {
            const removeSpecialcharcters = event.target.value.replace(/[^\d]/g, "");
            if (removeSpecialcharcters.length > 4) {
              onValueChange(removeSpecialcharcters.slice(0, 5), name)
            } else {
              onValueChange(removeSpecialcharcters, name);
            }
          } else if (name === 'duration' || name === 'hour1' || name === 'hour2') {
            onValueChange(event.target.value.replace(/[^\d.]/g, ""), name)
          } else {
            onValueChange(event.target.value, name);
          }
          validateField(event.target.value);
        }}
      ></input>
    </div>
  );
};

export default TextInput;
